import { createApp } from 'vue';
import BookingWidget from './BookingWidget.vue';
import store from '@/widgets/booking/store';
import { getRuntimeConfig, hasRuntimeClubId, logMissingClubId, setRuntimeConfig } from '@/widgets/booking/config/runtime';
function parseWidgetConfig(container) {
    const domain = container.getAttribute('domain') || undefined;
    const club = container.getAttribute('club') || undefined;
    const clubIdAttr = container.getAttribute('club-id') || container.getAttribute('filial-id');
    const userIdAttr = container.getAttribute('user-id');
    return {
        domain,
        club,
        clubId: clubIdAttr ? Number(clubIdAttr) : undefined,
        filialId: clubIdAttr ? Number(clubIdAttr) : undefined,
        userId: userIdAttr ? Number(userIdAttr) : undefined
    };
}
async function resolveClubId() {
    if (hasRuntimeClubId()) {
        return;
    }
    const runtimeConfig = getRuntimeConfig();
    const response = await fetch(`${runtimeConfig.domain.replace(/\/$/, '')}/api/v1.1/club`, {
        method: 'OPTIONS',
        headers: {
            Accept: 'application/json',
            Club: runtimeConfig.club,
            Source: 'booking-widget'
        }
    });
    if (!response.ok) {
        throw new Error(`Failed to resolve club-id: ${response.status}`);
    }
    const clubs = await response.json();
    const fallbackClubId = Array.isArray(clubs) ? Number(clubs[0]?.id) : NaN;
    if (!Number.isFinite(fallbackClubId) || fallbackClubId <= 0) {
        throw new Error('Failed to resolve club-id from OPTIONS /club');
    }
    setRuntimeConfig({ clubId: fallbackClubId, filialId: fallbackClubId });
}
// Монтируем приложение при загрузке DOM
const mountApp = async () => {
    const container = document.querySelector('fitbase-booking-widget');
    if (container) {
        setRuntimeConfig(parseWidgetConfig(container));
        if (!hasRuntimeClubId()) {
            try {
                await resolveClubId();
            }
            catch (error) {
                logMissingClubId();
                console.error('[booking-widget] Failed to resolve club-id automatically.', error);
            }
        }
        const app = createApp(BookingWidget);
        app.use(store);
        app.mount(container);
    }
};
// Монтируем сразу если DOM готов, иначе ждем
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountApp);
}
else {
    mountApp();
}
